import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import http from "./axios"

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'base-name',
            redirect: (to) => {
                if (to && to.path && to.path === "/") {
                    return "/dashboard"
                }
            }
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: () => import('./views/dashboard/index')
        },
        // {
        //     path: '/contacts',
        //     name: 'contacts',
        //     component: () => import('./views/contacts/index')
        // },
        {
            path: '/base-monitoring',
            name: 'base-monitoring',
            component: () => import('@/views/base-monitoring/BaseMonitoringList'),
            meta: {
                permission: 'BASE_MONITORING'
            }
        },
        {
            path: '/base-monitoring/:id/item/list',
            name: 'base-monitoring-edit-items-list',
            component: () => import('@/views/base-monitoring/BaseMonitoringItemList'),
            meta: {
                permission: 'BASE_MONITORING',
                actionPermission: 'BASE_MONITORING_EDIT'
            }
        },
        {
            path: '/base-monitoring/:id/item/new',
            name: 'base-monitoring-item-new',
            component: () => import('@/views/base-monitoring/item/BaseMonitoringItemEdit'),
            meta: {
                permission: 'BASE_MONITORING',
                actionPermission: 'BASE_MONITORING_NEW_ITEM'
            }
        },
        {
            path: '/base-monitoring/:id/item/edit/:itemId',
            name: 'base-monitoring-item-edit',
            component: () => import('@/views/base-monitoring/item/BaseMonitoringItemEdit'),
            meta: {
                permission: 'BASE_MONITORING',
                actionPermission: 'BASE_MONITORING_EDIT_ITEM'
            }
        },
        {
            path: '/pledge-monitoring',
            name: 'pledge-monitoring',
            component: () => import('@/views/pledge-monitoring/PledgeMonitoringList'),
            meta: {
                permission: 'PLEDGE_MONITORING'
            }
        },
        {
            path: '/pledge-monitoring/:id/credit',
            name: 'pledge-monitoring-credit-list',
            component: () => import('@/views/pledge-monitoring/credit/CreditList.vue'),
            meta: {
                permission: 'PLEDGE_MONITORING_CREDIT'
            }
        },
        {
            path: '/pledge-monitoring/:id/credit/:creditId/pledge',
            name: 'pledge-monitoring-credit-pledge-list',
            component: () => import('@/views/pledge-monitoring/pledge/PledgeList.vue'),
            meta: {
                permission: 'PLEDGE_MONITORING_CREDIT_PLEDGE'
            }
        },
        {
            path: '/pledge-monitoring/:id/credit/:creditId/pledge-real-estate/:pledgeId',
            name: 'pledge-monitoring-credit-pledge-real-estate-item-edit',
            component: () => import('@/views/pledge-monitoring/monitoring/real-estate/RealEstateMonitoringItemEdit.vue'),
            meta: {
                actionPermission: 'PLEDGE_MONITORING_CREDIT_PLEDGE_EDIT_ITEM'
            }
        },
        {
            path: '/pledge-monitoring/:id/credit/:creditId/pledge-fitment/:pledgeId',
            name: 'pledge-monitoring-credit-pledge-fitment-item-edit',
            component: () => import('@/views/pledge-monitoring/monitoring/fitment/FitmentMonitoringItemEdit.vue'),
            meta: {
                actionPermission: 'PLEDGE_MONITORING_CREDIT_PLEDGE_EDIT_ITEM'
            }
        },
        {
            path: '/pledge-monitoring/:id/credit/:creditId/pledge-auto/:pledgeId',
            name: 'pledge-monitoring-credit-pledge-auto-item-edit',
            component: () => import('@/views/pledge-monitoring/monitoring/auto/AutoMonitoringItemEdit.vue'),
            meta: {
                actionPermission: 'PLEDGE_MONITORING_CREDIT_PLEDGE_EDIT_ITEM'
            }
        },
        {
            path: '/pledge',
            name: 'pledge',
            component: () => import('@/views/pledge/PledgeList.vue'),
            meta: {
                permission: 'PLEDGE'
            }
        },
        {
            path: '/targeted-inspection-monitoring',
            name: 'targeted-inspection-monitoring',
            component: () => import('@/views/targeted-inspection-monitoring/TargetedInspectionMonitoringList.vue'),
            meta: {
                permission: 'TARGETED_INSPECTION_MONITORING'
            }
        },
        {
            path: '/targeted-inspection-monitoring/:id/credit/:creditItemId',
            name: 'targeted-inspection-monitoring-credit-item-edit',
            component: () => import('@/views/targeted-inspection-monitoring/monitoring/TargetedInspectionMonitoringItemEdit.vue'),
            meta: {
                actionPermission: 'TARGETED_INSPECTION_MONITORING_CREDIT_EDIT_ITEM'
            }
        },
        {
            path: '/didox-report',
            name: 'didox-report',
            component: () => import('@/views/didox-report/DidoxReport.vue'),
            meta: {
                permission: 'DIDOX'
            }
        }
    ]
})

router.beforeEach((to, from, next) => {

    if (to.path.split("/")[1] !== from.path.split("/")[1]) {
        store.dispatch("deleteFiltersData")
    }

    next()

    return next;
});

export default router;